export const changfang1 = [
    {
        point_id: '1694519851281965056',
        name: 'N42',
        top: -2,
        left: 15,
        data: ''
    },
    {
        point_id: '1694519908546797568',
        name: 'N43',
        top: 22,
        left: 28,
        data: ''
    },
    {
        point_id: '1694519961084649472',
        name: 'N44',
        top: 30,
        left: 40,
        data: ''
    },
    {
        point_id: '1694520007192633344',
        name: 'N45',
        top: 53,
        left: 40,
        data: ''
    },
    {
        point_id: '1694520058157621248',
        name: 'N46',
        top: 63,
        left: 55,
        data: ''
    },
    {
        point_id: '1694520109592371200',
        name: 'N47',
        top: 14,
        left: 2,
        data: ''
    },
    {
        point_id: '1694520156778291200',
        name: 'N48',
        top: 64,
        left: 2,
        data: ''
    },
    {
        point_id: '1694520293667790848',
        name: 'N49',
        top: 86,
        left: 49,
        data: ''
    },
    {
        point_id: '1694520331420721152',
        name: 'N50',
        top: 47,
        left: 80,
        data: ''
    },
    {
        point_id: '1694520378329817088',
        name: 'N51',
        top: 10,
        left: 90,
        data: ''
    },
    {
        point_id: '1694520413062848512',
        name: 'N52',
        top: 8,
        left: 52,
        data: ''
    },
    {
        point_id: '1694520452275396608',
        name: 'N53',
        top: 41,
        left: 35,
        data: ''
    },
    {
        point_id: '1694520494981799936',
        name: 'N54',
        top: 74,
        left: 52,
        data: ''
    },
    {
        point_id: '1694520528909524992',
        name: 'N55',
        top: 74,
        left: 17,
        data: ''
    },
]
export const changfang1_tu = [
    {
        point_id: '1694520568201764864',
        name: 'N56',
        top: 15,
        left: 20,
        data: ''
    },
    {
        point_id: '1694520606504148992',
        name: 'N57',
        top: 29,
        left: 51,
        data: ''
    },
    {
        point_id: '1694520653585211392',
        name: 'N58',
        top: 29,
        left: 20,
        data: ''
    },
    {
        point_id: '1694520693489819648',
        name: 'N59',
        top: 44,
        left: 51,
        data: ''
    },
    {
        point_id: '1694520742722560000',
        name: 'N60',
        top: 57,
        left: 35,
        data: ''
    },
    {
        point_id: '1694520774427303936',
        name: 'N61',
        top: 71,
        left: 35,
        data: ''
    },
    {
        point_id: '1694520807520362496',
        name: 'N62',
        top: 71,
        left: 66,
        data: ''
    },
]
export const changfang2 = [
    {
        point_id: '1694520846846156800',
        name: 'N63',
        top: 77,
        left: 10,
        data: ''
    },
    {
        point_id: '1694520886155173888',
        name: 'N64',
        top: 15,
        left: 21,
        data: ''
    },
    {
        point_id: '1694521003482439680',
        name: 'N65',
        top: 15,
        left: 71,
        data: ''
    },
    {
        point_id: '1694521035497562112',
        name: 'N66',
        top: 22,
        left: 59,
        data: ''
    },
    {
        point_id: '1694521069643390976',
        name: 'N67',
        top: 35,
        left: 10,
        data: ''
    },
    {
        point_id: '1694521100651880448',
        name: 'N68',
        top: 40,
        left: 35,
        data: ''
    },
    {
        point_id: '1694521139575021568',
        name: 'N69',
        top: 40,
        left: 81,
        data: ''
    },
    {
        point_id: '1694521178905010176',
        name: 'N70',
        top: 47,
        left: 46,
        data: ''
    },
    {
        point_id: '1694521220386676736',
        name: 'N71',
        top: 60,
        left: 10,
        data: ''
    },
    {
        point_id: '1694521261679599616',
        name: 'N72',
        top: 65,
        left: 70,
        data: ''
    },
    {
        point_id: '1694521311365324800',
        name: 'N73',
        top: 72,
        left: 59,
        data: ''
    },
    {
        point_id: '1694521355506180096',
        name: 'N74',
        top: 5.5,
        left: 42,
        data: ''
    },
    {
        point_id: '1694521391992430592',
        name: 'N75',
        top: 5.5,
        left: 42,
        data: ''
    },
    {
        point_id: '1694521426087927808',
        name: 'N76',
        top: 30,
        left: 58,
        data: ''
    },
    {
        point_id: '1694521461076811776',
        name: 'N77',
        top: 55,
        left: 58,
        data: ''
    },
    {
        point_id: '1694521499949621248',
        name: 'N78',
        top: 80,
        left: 41,
        data: ''
    },
    {
        point_id: '1694521535320186880',
        name: 'N79',
        top: 77,
        left: 81,
        data: ''
    },
]
export const hv = [
    {
        point_id: '1694519073364402176',
        name: 'N26',
        top: 18,
        left: 43,
        data: ''
    },
    {
        point_id: '1694519132151767040',
        name: 'N27',
        top: 41,
        left: 41,
        data: ''
    },
    {
        point_id: '1694519175512481792',
        name: 'N28',
        top: 49,
        left: 7,
        data: ''
    },
    {
        point_id: '1694519230243954688',
        name: 'N29',
        top: 49,
        left: 63,
        data: ''
    },
    {
        point_id: '1694519274300923904',
        name: 'N30',
        top: 71,
        left: 37,
        data: ''
    },
    {
        point_id: '1694519319385497600',
        name: 'N31',
        top: 27,
        left: 35,
        data: ''
    },
    {
        point_id: '1694519368664375296',
        name: 'N32',
        top: 27,
        left: 57,
        data: ''
    },
    {
        point_id: '1694519417653846016',
        name: 'N33',
        top: 58,
        left: 35,
        data: ''
    },
    {
        point_id: '1694519461014560768',
        name: 'N34',
        top: 58,
        left: 57,
        data: ''
    },
]
export const mv = [
    {
        point_id: '1692473999612862464',
        name: 'N01',
        top: -2,
        left: 28,
        data: ''
    },
    {
        point_id: '1694263925538971648',
        name: 'N02',
        top: 22,
        left: 68,
        data: ''
    },
    {
        point_id: '1694517528493187072',
        name: 'N03',
        top: 22,
        left: 36,
        data: ''
    },
    {
        point_id: '1694517652636196864',
        name: 'N04',
        top: 31,
        left: 29,
        data: ''
    },
    {
        point_id: '1694517710937022464',
        name: 'N05',
        top: 31,
        left: 62,
        data: ''
    },
    {
        point_id: '1694517782873530368',
        name: 'N06',
        top: 54,
        left: 62,
        data: ''
    },
    {
        point_id: '1694517866780581888',
        name: 'N07',
        top: 64,
        left: 16,
        data: ''
    },
    {
        point_id: '1694517934778638336',
        name: 'N08',
        top: 64,
        left: 48,
        data: ''
    },
    {
        point_id: '1694517981675151360',
        name: 'N09',
        top: 84,
        left: 71,
        data: ''
    },
    {
        point_id: '1694518032824688640',
        name: 'N10',
        top: 84,
        left: 19,
        data: ''
    },
    {
        point_id: '1694518080157409280',
        name: 'N11',
        top: 8,
        left: 16,
        data: ''
    },
    {
        point_id: '1694518123258077184',
        name: 'N12',
        top: 8,
        left: 55,
        data: ''
    },
    {
        point_id: '1694518190580850688',
        name: 'N13',
        top: 41,
        left: 36,
        data: ''
    },
    {
        point_id: '1694518234600071168',
        name: 'N14',
        top: 41,
        left: 55,
        data: ''
    },
    {
        point_id: '1694518279302963200',
        name: 'N15',
        top: 73,
        left: 36,
        data: ''
    },
    {
        point_id: '1694518326392414208',
        name: 'N16',
        top: 73,
        left: 55,
        data: ''
    },
]
export const jueyuanchejian = [
    {
        point_id: '1694519520082944000',
        name: 'N35',
        top: 14,
        left: 38,
        data: ''
    },
    {
        point_id: '1694519564991356928',
        name: 'N36',
        top: 39,
        left: 47,
        data: ''
    },
    {
        point_id: '1694519613657866240',
        name: 'N37',
        top: 71,
        left: 38,
        data: ''
    },
    {
        point_id: '1694519669513412608',
        name: 'N38',
        top: 27,
        left: 46,
        data: ''
    },
    {
        point_id: '1694519716258930688',
        name: 'N39',
        top: 60,
        left: 46,
        data: ''
    },
]
export const jueyuanchejian_tu = [
    {
        point_id: '1694519764803805184',
        name: 'N40',
        top: 9,
        left: 34,
        data: ''
    },
    {
        point_id: '1694519809909350400',
        name: 'N41',
        top: 23,
        left: 34,
        data: ''
    },
]
export const shengchanchejian = [
    {
        point_id: '1694518392209432576',
        name: 'N17',
        top: 77,
        left: 76,
        data: ''
    },
    {
        point_id: '1694518447075123200',
        name: 'N18',
        top: 41,
        left: 62,
        data: ''
    },
    {
        point_id: '1694518510195204096',
        name: 'N19',
        top: 22,
        left: 55,
        data: ''
    },
    {
        point_id: '1694518560430383104',
        name: 'N20',
        top: 21,
        left: 38,
        data: ''
    },
    {
        point_id: '1694518668903473152',
        name: 'N21',
        top: 3,
        left: 31,
        data: ''
    },
    {
        point_id: '1694518871148617728',
        name: 'N22',
        top: 12,
        left: 13,
        data: ''
    },
    {
        point_id: '1694518928421838848',
        name: 'N23',
        top: 18,
        left: 21,
        data: ''
    },
    {
        point_id: '1694518968641019904',
        name: 'N24',
        top: 53,
        left: 45,
        data: ''
    },
    {
        point_id: '1694519025826160640',
        name: 'N25',
        top: 53,
        left: 70,
        data: ''
    },
]